<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M34 27H18V84H81V27L66.5 27" stroke="black" stroke-width="4"/>
<path d="M66 33V21.6667H60.4828V16H39.5172V21.6667H34V33H66Z" stroke="black" stroke-width="4"/>
<path d="M30 47.5H70" stroke="black" stroke-width="4"/>
<path d="M30 58.5H70" stroke="black" stroke-width="4"/>
<path d="M30 69.5H70" stroke="black" stroke-width="4"/>
</svg>

</template>
